import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'ru', 'es', 'de'],
    defaultNS: 'common',
    ns: ['common'],
    debug: false,

    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}.json',
    },

    react: {
      useSuspense: true,
    },
  });

// RTL languages — currently none supported.
// Helpers retained so reintroducing an RTL language (e.g., Arabic) only
// requires adding it to the rtlLanguages array; consumers stay unchanged.
export const rtlLanguages = [];
export const isRTL = (lang) => rtlLanguages.includes(lang);

export default i18n;
